






















































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class RowHeader extends Vue {
  private plantSort (name: string) {
    this.$emit('plant-sort', name)
  }
}
